import Component from '../core/Component'
import ConnectLine, { EMITS as CONNECTLINE_EMITS } from './ConnectLine'

export default class ConnectLinePoint extends Component {
    constructor($element, options = {}) {
        super($element, options)

        this.ref = {
            line: null
        }
        this.ref.line = document.querySelector(`[data-point-id="${this.element.id}"]`)
        this.line = null

        this.intObserver = new IntersectionObserver(this.handleIntersectionObserver, {
            rootMargin: '0px',
            threshold: 1.0
        })
    }

    prepare() {
        setTimeout(() => {
            this.intObserver.observe(this.element)
        }, 500);
    }

    destroy() {
        this.intObserver.disconnect()
        if (this.line) {
            this.line.destroy()
        }
    }

    handleIntersectionObserver = entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return
            }
            const element = entry.target
            if (element !== this.element) {
                return
            }

            this.line = new ConnectLine($(this.ref.line))
            this.line.prepare()
            setTimeout(() => {
                this.line.showSvg()
            }, 0);
            element.classList.add('is-visible')
            setTimeout(() => {
                element.classList.add('is-pulsing')
            }, 2000);

            this.intObserver.disconnect()
        })
    }
}



// WEBPACK FOOTER //
// ./components/ConnectLinePoint.js